import React, { useState } from "react";

export default function InputPadraoProduto({
  value,
  onChange,
  placeholder = "Digite aqui",
  type = "text",
  className = "",
  readOnly = false,
  disabled = false,
  iconRight = null, // 👈 ícone opcional à direita
}) {
  const [focused, setFocused] = useState(false);

  // Verifica se o campo tem valor (mesmo que seja 0)
  const hasValue =
    value !== undefined && value !== null && String(value).length > 0;

  return (
    <div className="relative w-full">
      {/* Label flutuante */}
      <label
        className={`absolute left-2 transition-all duration-200 pointer-events-none
          ${
            disabled
              ? focused || hasValue
                ? "-top-4 text-xs text-[#B0B0B0] font-normal"
                : "top-2.5 text-sm text-[#B0B0B0] font-medium"
              : focused || hasValue
              ? "-top-4 text-xs text-gray-600 font-normal"
              : "top-2.5 text-sm text-[#00000080] font-medium"
          }`}
        style={{
          fontFamily: "Comfortaa, cursive",
        }}
      >
        {placeholder}
      </label>

      {/* Input */}
      <input
        type={type}
        value={value}
        onChange={onChange}
        onFocus={() => !disabled && setFocused(true)}
        onBlur={() => !disabled && setFocused(false)}
        readOnly={readOnly}
        disabled={disabled}
        className={`w-full border-0 border-b px-2 py-2 pr-7 text-sm
          ${
            disabled
              ? "border-[#b5b5b5] text-[#A0A0A0] placeholder-[#B5B5B5] cursor-not-allowed pointer-events-none bg-transparent"
              : "border-[#b5b5b5] hover:border-b-2 hover:border-[#b5b5b5] focus:border-[#0088e3] focus:border-b-2"
          }
          focus:outline-none transition-all duration-200 ${className}`}
      />

      {/* Ícone à direita (quando existir) */}
      {iconRight && (
        <span className="absolute right-1 top-1/2 -translate-y-1/2 text-[#0088e3]">
          {iconRight}
        </span>
      )}
    </div>
  );
}
